<template>
  <div class="carrot">

    <div class="main-wrapper">
      <Menu></Menu>
      <div class="page-wrapper">
        <div class="page-content ">
          <div class="row">
            <div class="col-xl-12">
              <h3 class="page-title">학습자 관리</h3>
              <p class="lead">
                - CARROT 앱에 로그인 성공한 회원만 표시됩니다.<br>
                - 회원구분: CTM(전화영어 학습자), ITM(글로벌 오프라인 학습자), 통합 (전화영어 + 글로벌 오프라인 학습자)
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive text-center">
                    <table class="table table-bordered">
                      <thead>
                      <tr>
                        <th width="60">이름</th>
                        <td>
                          <input @keyup.enter="getMembers(1)" v-model="filter.name" type="text"
                                 class="form-control" id=""
                                 placeholder="검색어를 입력하세요.">
                        </td>
                        <th>ID(Email)</th>
                        <td>
                          <input @keyup.enter="getMembers(1)" v-model="filter.uid" type="text"
                                 class="form-control" id=""
                                 placeholder="검색어를 입력하세요.">
                        </td>
                      </tr>
                      <tr>
                        <th>회사명</th>
                        <td>
                          <input @keyup.enter="getMembers(1)" v-model="filter.companyname"
                                 type="text" class="form-control" id=""
                                 placeholder="검색어를 입력하세요.">
                        </td>
                        <th>Mobile</th>
                        <td>
                          <input @keyup.enter="getMembers(1)" v-model="filter.mobile" type="text"
                                 class="form-control" id=""
                                 placeholder="검색어를 입력하세요.">
                        </td>
                      </tr>
                      </thead>
                    </table>
                  </div>
                  <div class="text-right mt-2">
                    <button type="submit" class="btn btn-primary"
                            @click="getMembers(filter.page, filter.email, filter.name, filter.companyname, filter.mobile, filter.name)">
                      검색
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive text-center" style="overflow-y: hidden;">
                    <table class="table table-hover table-bordered">
                      <tr>
                        <th>ITM</th>
                        <th>CTM</th>
                        <th>통합</th>
                        <th>자체유입</th>
                      </tr>
                      <tr>
                        <td>{{ count.itmCount }}</td>
                        <td>{{ count.ctmCount }}</td>
                        <td>{{ count.totalCount }}</td>
                        <td>{{ count.selfCount }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="clear mb-2">
                    <select @change="getMembers(1)" v-model="filter.division"
                            class="form-control fl w-20per">
                      <option value="">구분선택</option>
                      <option value="CTM">CTM</option>
                      <option value="ITM">ITM</option>
                      <option value="통합">통합</option>
                      <option value="자체유입">자체유입</option>
                    </select>

                    <select @change="getMembers(1)" v-model="filter.membership"
                            class="form-control fl ml-10 w-20per">
                      <option value="">회원구분 선택</option>
                      <option value="B2C">B2C</option>
                      <option value="B2B">B2B</option>
                    </select>
                    <!-- <div class="float-right">
                    <button type="button" class="btn btn-primary btn-icon-text" @click="excelDown()">
                        <i class="btn-icon-prepend" data-feather="file-text"></i>
                        Excel Download
                    </button>
                </div> -->
                  </div>
                  <div class="table-responsive text-center" style="overflow-y: hidden;">
                    <table class="table table-hover table-bordered">
                      <tr>
                        <th style="width: 5%">No</th>
                        <th style="width: 10%">구분</th>
                        <th style="width: 10%">회원구분</th>
                        <th style="width: 10%">회사명</th>
                        <th style="width: 10%">이름</th>
                        <th>ID(이메일)</th>
                        <th style="width: 10%">Mobile</th>
                        <th style="width: 10%">최근접속일</th>
                        <th style="width: 10%">최초등록일</th>
                      </tr>
                      <tr v-for="(item,index) in members" :key="item.idx">
                        <td>{{ (result.total - (result.currentPage - 1) * result.perPage  ) - index }}</td>
                        <td>{{ item.division }}</td>
                        <td>{{ item.membership }}</td>
                        <td>{{ item.companyname }}</td>
                        <td><a :href="('/memberview/' + item.idx )">{{ item.userName }}</a></td>
                        <td>{{ item.uid }}</td>
                        <td>{{ item.mobile }}</td>
                        <td>{{ item.currentLogin }}</td>
                        <td>{{ item.updateDate }}</td>
                      </tr>
                      <tr v-if="lastpage === 0">
                        <td colspan="10">검색하신 학습자가 존재하지 않습니다.</td>
                      </tr>
                    </table>

                    <!-- <carrot-pagination v-model="search.page" :page="search.page" :total="total" :pagesize="50" @change="onPage" ></carrot-pagination> -->
                    <div v-if="lastpage !== 0" style="padding-left:40%; padding-top:20px;">
                      <paginate :page-count="lastpage" :page-range="3" :margin-pages="2"
                                :click-handler="clickCallback" :prev-text="'Prev'"
                                :next-text="'Next'" :container-class="'pagination'"
                                :page-class="'page-link'">
                      </paginate>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Menu from '../../components/inc_menu.vue'
import Paginate from 'vuejs-paginate';

export default {
  name: 'member',
  components: {
    Menu,
    Paginate,

  },
  props: {
    msg: String
  },
  data: () => ({
    members: [],
    count: {},
    filter: {
      name: '',
      email: '',
      companyname: '',
      mobile: '',
      division: '',
      membership: '',
      page: 1
    },
    lastpage: 1
  }),
  mounted() {
    this.getMembers(1);
  },
  methods: {
    clickCallback: function (pageNum) {
      // console.log(pageNum)
      this.filter.page = pageNum;
      this.getMembers();
    },
    initPage: function () {

    },

    getMembers: function (page) {
      if (page !== undefined) {
        this.filter.page = page;
      }
      const url = this.$store.state.host + "/v1/admin/users";
      var params = {
        page: (this.filter.page === '' ? null : this.filter.page),
        uid: (this.filter.uid === '' ? null : this.filter.uid),
        companyname: (this.filter.companyname === '' ? null : this.filter.companyname),
        mobile: (this.filter.mobile === '' ? null : this.filter.mobile),
        division: (this.filter.division === '' ? null : this.filter.division),
        membership: (this.filter.membership === '' ? null : this.filter.membership),
        name: (this.filter.name === '' ? null : this.filter.name)
      };

      this.axios.get(url, {params})
      .then((res) => {
        if (res.data.status === 105) {
          this.members = [];
          this.count = {
            itmCount: 0,
            ctmCount: 0,
            totalCount: 0,
            selfCount: 0,
          };
          this.lastpage = 0
        } else {
          this.result = res.data.result.userList;
          this.members = res.data.result.userList.value;
          this.count = res.data.result.statics;
          this.lastpage = res.data.lastPage;
        }
      });
    },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">

</style>
